export const researchDepths = {
  express: { label: 'Экспресс', description: 'Первичная картина по всем вопросам, проверка решающих утверждений.' },
  standard: { label: 'Стандарт', description: 'Обоснованный ответ, проверка существенных утверждений и независимости источников.' },
  deep: { label: 'Глубокое', description: 'Контрдоказательства, альтернативы, допущения и границы применимости.' },
};

export const researchChecks = {
  initial_sources: 'Первичный ответ по источникам',
  claim_verification: 'Проверка решающих утверждений',
  comparability: 'Сопоставимость данных',
  independence: 'Независимость источников',
  counter_evidence: 'Поиск контрдоказательств',
  alternatives: 'Альтернативные объяснения',
  assumptions: 'Проверка допущений',
  applicability: 'Границы применимости',
};
